import { useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "../contexts/UserContext";

interface Service<T> {
  deleteListing: (id: string) => Promise<{ data: T }>;
}

interface DeleteHandlerOptions<T> {
  onSuccess?: (info: T) => void;
  onError?: (error: any) => void;
}

export const useDeleteHandler = <T extends { id?: string; creatorId?: string }>(
  service: Service<T>
) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const { user, userId, userRole } = useUser();

  const handleDelete = async (data: T, options?: DeleteHandlerOptions<T>) => {
    if (data && data.id) {
      setIsDeleting(true);
      try {
        if (
          user &&
          (data.creatorId === userId ||
            userRole.includes("admin") ||
            userRole.includes("moderator"))
        ) {
          const response = await service.deleteListing(data.id);
          const info = response.data;

          toast.success("Listing successfully deleted!", {
            position: "bottom-right",
          });

          if (options?.onSuccess) options.onSuccess(info);
          return info;
        } else {
          throw new Error("Unauthorized to delete this listing");
        }
      } catch (error) {
        console.error("Error deleting listing:", error);
        toast.error(
          "Failed to fetch delete listing. Please check the error details",
          {
            position: "bottom-right",
          }
        );
        if (options?.onError) options.onError(error);
        return null;
      } finally {
        setIsDeleting(false);
      }
    }
  };

  return {
    handleDelete,
    isDeleting,
  };
};
